import clsx from 'clsx';
import { useState } from 'react';
import { IconChevronDown } from 'src/icons';
import SvgInfoWarning from 'src/icons/InfoWarning';

type RejectionNoteBannerProps = {
  rejectionReason: string | undefined;
};

export const RejectionNoteBanner = ({ rejectionReason }: RejectionNoteBannerProps) => {
  const [isRejectionNoteOpen, setIsRejectionNoteOpen] = useState(false);

  if (!rejectionReason) return null;

  return (
    <div
      className={`flex w-full flex-col gap-2 bg-accent-tomato-800 px-4 py-5 md:gap-4 md:px-10 ${
        isRejectionNoteOpen ? 'z-dropdown' : 'z-auto'
      }`}
    >
      <button
        className="flex w-full cursor-pointer flex-col gap-2 text-left md:flex-row md:items-center md:gap-2"
        onClick={() => setIsRejectionNoteOpen(!isRejectionNoteOpen)}
      >
        <div className="flex items-center gap-1">
          <SvgInfoWarning className="h-5 w-5 text-primary-400" />
          <span className="text-neutral-100 typography-loud-md">
            You&apos;re revising a rejected invoice.
          </span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-schedule-red-800 typography-loud-md">Rejection note</span>
          <IconChevronDown
            className={clsx(
              'h-4 w-4 text-schedule-red-800 transition-transform duration-300 ease-in-out',
              isRejectionNoteOpen && 'rotate-180',
            )}
          />
        </div>
      </button>
      {isRejectionNoteOpen && (
        <div className="text-neutral-200 typography-body-sm">{rejectionReason}</div>
      )}
    </div>
  );
};
